import { render, staticRenderFns } from "./PatientAddPage.vue?vue&type=template&id=37334cc4&scoped=true&"
import script from "./PatientAddPage.vue?vue&type=script&lang=js&"
export * from "./PatientAddPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37334cc4",
  null
  
)

export default component.exports